define([
	'internal_util/Util'
], function (
	Util
) {
	'use strict';

	/**
	 * UIState class
	 */
	return function (id) {
		var _id;

		if (Util.isValidString(id)) {
			_id = id;
		} else {
			throw new Error('no valid id found');
		}


		// public methods

		this.id = function () {
			return _id;
		};

		this.title = function () {
			throw new Error('not implemented');
		};
		
		this.poweredByImage = function () {
			throw new Error('not implemented');
		};

		this.content = function () {
			throw new Error('not implemented');
		};

		this.controls = function () {
			throw new Error('not implemented');
		};

		this.enter = function (doneCallback, data) {
			throw new Error('not implemented');
		};

		this.leave = function (doneCallback) {
			throw new Error('not implemented');
		};

		this.toObject = function () {
			return {
				id : _id
			};
		};
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/state/UIState.js
// module id = 13
// module chunks = 3